export default function PwaBackground() {
  return (
    <div className="au-bg" aria-hidden="true">
      <div className="au-blob au-blob-1" />
      <div className="au-blob au-blob-2" />
      <div className="au-blob au-blob-3" />
    </div>
  );
}
